import { getYoutubeVideoCover } from "@/utils/youtube";
import BlogContent from "../BlogContent";
import { BLOG_TAGS } from "../BlogTags";

const PODCAST_3: BlogContent = {
    id: 15,
    label: "Kodėl neveikia tavo papildai? Miegas, energija ir stresas",
    description: "Sužinokite, kaip personalizuoti maisto papildai gali tapti tikslu keliu į realius rezultatus. Kaip pasiekti greičiausią ir didžiausią efektą, remiantis mokslo duomenimis, o ne rinkodaros pažadais. Taip pat, atskleidžiame, kodėl daugelis papildų neveikia ir kaip išsirinkti tai, kas iš tiesų veikia tavo organizmui.",
    descriptionInner: "Sužinokite, kaip personalizuoti maisto papildai gali tapti tikslu keliu į realius rezultatus. Kaip pasiekti greičiausią ir didžiausią efektą, remiantis mokslo duomenimis, o ne rinkodaros pažadais. Taip pat, atskleidžiame, kodėl daugelis papildų neveikia ir kaip išsirinkti tai, kas iš tiesų veikia tavo organizmui.",
    img_src: getYoutubeVideoCover("AxOWUEf6fhM"),
    alt: "Podcast ep.3",
    tags: [BLOG_TAGS.PODCASTS.label, BLOG_TAGS.SUPPLEMENTS.label],
    innerData: [
    {
        id: 1,
        description: [
            "Kodėl neveikia tavo papildai? Duomenimis grįstas požiūris į miegą, energiją ir stresą Papildų rinkoje itin daug chaoso: reklamos, prieštaringa informacija, dešimtys kapsulių ir neaiškios dozuotės. Dažnai žmonės tikisi greito efekto, bet tikrasis klausimas yra ne „kokio papildo dar trūksta?“, o kas vyksta mano organizme iš tikrųjų.",
            "Šiame epizode Vaiva, MD ir sveikos gyvensenos praktikė ir farmacininkas Jokūbas kalba apie:",
            " •	Kodėl vien melatoninas neišsprendžia miego problemų;",
            " •	Kaip iš tiesų pakelti energijos lygį be kavos priklausomybės;",
            " •	Kaip streso ir nerimo valdymą derinti su papildais ir gyvensenos įpročiais;"
        ]
    }],
    podcasts: {
        youtube: "AxOWUEf6fhM",
        spotify: "1K0pqXtI9yxlY8CWMkP1Ct?si=f9bb7f3031204c0e",
        apple: "1000730774357"
    }
}

export default PODCAST_3;